<template>
    <div>

        <PageTitle v-bind:title="title" v-bind:admin="false" />

        <div class="alert alert-danger" v-if="errors.load">
            {{ errors.load }}
        </div>    
        <Loader v-if="loading" />
        <div v-else>

            <form>
                <input type="hidden" class="form-control" id="id" name="id" v-model="data.id">
                <div class="form-group">
                    <label for="fullname" class="col-form-label">Полное имя: <span class="badge badge-info" title="Эта информация будет видна всем пользователям!">публичное поле</span></label>
                    <input type="text" class="form-control" id="fullname" name="fullname" v-model="data.fullname">
                </div>
                <div class="form-group">
                    <label for="description" class="col-form-label">Описание: <span class="badge badge-info" title="Эта информация будет видна всем пользователям!">публичное поле</span></label>
                    <input type="text" class="form-control" id="description" name="description" v-model="data.description">
                </div>
                <div class="form-group">
                    <label for="contacts" class="col-form-label">Контактная информация: <span class="badge badge-info" title="Эта информация будет видна всем пользователям!">публичное поле</span></label>
                    <input type="text" class="form-control" id="contacts" name="contacts" v-model="data.contacts">
                </div>
            </form>
            <button type="button" class="btn btn-primary" @click.prevent="editRecord()">Сохранить изменения</button>
            <div class="alert alert-danger" v-if="errors.edit">
                {{ errors.edit }}
            </div>









            <h3 class="mt-5">Загрузить фото</h3>
            <img :src="userphoto" alt="" width="300">
            <form @submit.prevent="submit">
                <!-- <div class="form-group">
                    <input type="text" class="form-control" placeholder="Name" v-model="name">
                </div> -->
                <div class="form-group">
                    <div class="custom-file">
                        <input type="file"
                            class="custom-file-input"
                            id="customFile"
                            @change="onAttachmentChange"
                        >
                        <label class="custom-file-label" for="customFile">Выбрать файл</label>
                    </div>
                </div>
                <div class="form-group">
                    <button type="submit" class="btn btn-primary">Загрузить</button>
                </div>
                <div class="alert alert-danger" v-if="errors.uploadfile">
                    {{ errors.uploadfile }}
                </div>
            </form>



        </div>
    </div>
</template>

<script>
import axios from 'axios'
import Loader from '@/components/Loader'
import PageTitle from '@/components/PageTitle'


export default {
    name: 'dashboard',
    data() {
        return {
            loading: true,
            data: [],
            errors: {load: '', edit: '', uploadfile: ''},
            //name: 'myname',
            attachment: null,
            userphoto: null,
            title: 'Редактирование профиля',
        }
    },
    async mounted() {
       this.loadData()
    },
    methods: {
        async loadData() {
            this.errors.load = ''
            try {
                this.loading = true
                let response = await axios.get('user/profileEdit')
                this.data = response.data.user
                this.userphoto = this.data.userphoto
                this.loading = false
            }
            catch (e) {
                /*
                if (e.response.status == 520) {
                    this.errors.load = e.response.data.error
                }
                else if (e.response.status == 401) {
                    this.errors.load = e.response.data.error
                }
                else {
                    this.errors.load = 'Ошибка при загрузке данных'
                }
                */
                this.errors.load = 'Ошибка при загрузке данных'
            }
        },

        //
        // Edit record.
        //
        async editRecord() {
            this.errors.validationEdit = {}
            this.errors.edit = ''
            try {
                //let response = await axios.post('admin/courses/'+this.data.id, {id: this.data.id, name: this.data.name, description: this.data.description, department_id: this.data.department_id, _method: 'PUT'})
                let response = await axios.post('user/profileUpdate/'+this.data.id,  Object.assign(this.data, {_method: 'PUT'}))
                if (response.status == 200) {
                    this.loadData()
                }
            }
            catch(e) {
                if (e.response.status == 422) {
                    this.errors.validationEdit = e.response.data.errors
                }               
                else if (e.response.status == 520) {
                    this.errors.edit = e.response.data.error
                }
                else {
                    this.errors.edit = "Неизвестная ошибка при редактировании профиля."
                }
            }
        },


        onAttachmentChange (e) {
            this.attachment = e.target.files[0]
        },
        submit () {
            this.errors.uploadfile = ''
            const config = { 'content-type': 'multipart/form-data' }
            const formData = new FormData()
            formData.append('name', this.name)
            formData.append('attachment', this.attachment)

            axios.post('user/profileUploadAvatar', formData, config)
                //.then(response => console.log(response.data.message))
                //.catch(error => console.log(error))
                .then(response => {
                    this.userphoto = response.data.userphoto
                    //console.log(this.path);
                })
                .catch(error => {
                    if (error.response.status == 520) {
                        this.errors.uploadfile = error.response.data.error
                    }
                    if (error.response.status == 422) {
                        this.errors.uploadfile = error.response.data.errors.attachment[0]
                    }
                    else {
                        this.errors.uploadfile = 'Неизвестная ошибка при загрузке файла.'
                    }
                })
        },



    },
    components: {
        Loader,
        PageTitle,
    }
}
</script>